import queryString from 'query-string'
import { useRouter } from 'next/router'
import { ParsedUrlQueryInput } from 'querystring'

export const getHash = () => {
  if (typeof window === 'undefined') {
    return ''
  }
  const hash = window.location.hash
  return hash ? hash.slice(1) : ''
}

export const getQuery = (path: string) => {
  return queryString.parse(path.split('?')[1]) as ParsedUrlQueryInput
}

export const redirect = (url: string, query?: ParsedUrlQueryInput) => {
  if (typeof window === 'undefined') {
    return
  }
  const urlQuery = query ? queryString.stringify(query) : ''
  window.location.href = `${url}${urlQuery ? `?${urlQuery}` : ''}`
}

export const useParsedRouter = () => {
  const router = useRouter()
  const query = getQuery(router.asPath)
  const hash = getHash()

  return {
    router,
    query,
    hash,
    redirect,
  }
}
